module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "hidden-md-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])]), _vm._v(" "), (_vm.$session.user && _vm.$session.user.admin) ? _c('li', {
    staticClass: "nav-item px-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/users',
      "exact": ""
    }
  }, [_vm._v("Users")])], 1) : _vm._e(), _vm._v(" "), (_vm.$session.user && _vm.$session.user.admin) ? _c('li', {
    staticClass: "nav-item px-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/machines',
      "exact": ""
    }
  }, [_vm._v("Machines")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.$session.user.firstname) + " " + _vm._s(_vm.$session.user.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Account")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/profile',
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.$session.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item d-md-down-none"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efddb6e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 735
// module chunks = 8